import api from "@/lib/api";

let cache = null;

/**
 * The product categories (Admin → Mega Menu) that actually contain at least one
 * published product, in admin order, each with `sample` = its first product.
 * A 1-item query per category (~1KB) rather than downloading the whole catalogue.
 * The promise is cached for the session so the footer and the homepage share it.
 */
export function loadProductCategories() {
  if (!cache) {
    cache = (async () => {
      const cats = (await api.get("/megamenu/categories")).data || [];
      const withSample = await Promise.all(
        cats.map(async (c) => {
          try {
            const r = await api.get("/products", { params: { category: c.title, limit: 1 } });
            return { ...c, sample: (r.data || [])[0] || null };
          } catch {
            return { ...c, sample: null };
          }
        })
      );
      return withSample.filter((c) => c.sample).sort((a, b) => (a.order || 0) - (b.order || 0));
    })().catch((e) => { cache = null; throw e; });
  }
  return cache;
}

/** Resolves the subset of `urls` that actually load as images (each with a timeout). */
export function loadableImages(urls, timeoutMs = 6000) {
  return Promise.all(
    urls.map(
      (u) =>
        new Promise((resolve) => {
          if (!u) return resolve(false);
          const img = new Image();
          const t = setTimeout(() => resolve(false), timeoutMs);
          img.onload = () => { clearTimeout(t); resolve(true); };
          img.onerror = () => { clearTimeout(t); resolve(false); };
          img.src = u;
        })
    )
  );
}
